import { ErrorContent } from '@embed/components/VideoPlayer/Player3/components/ErrorContent/ErrorContent';
import { PlayerModal } from '@embed/components/VideoPlayer/Player3/components/PlayerModal';
import Modal from '@player/components/Modal';
/**
 *
 */
export const ErrorModal = ({ title, description, footer, onDismiss, }) => {
    return (<PlayerModal>
      <Modal.Menu>
        <ErrorContent title={title} description={description} footer={footer} onDismiss={onDismiss}/>
      </Modal.Menu>
    </PlayerModal>);
};
export default ErrorModal;
